import React, { useEffect } from 'react';
import './GlovoNotePrint.css';

const GlovoNotePrint = () => {
  const params = new URLSearchParams(window.location.search);
  const textParam = params.get('text') ? decodeURIComponent(params.get('text')) : '';
  const orderNumberParam = params.get('orderNumber');

  // Prefer sessionStorage backup for large HTML payloads
  const sessionHtml = typeof window !== 'undefined' ? sessionStorage.getItem('glovoNoteHtml') : null;
  const sessionOrder = typeof window !== 'undefined' ? sessionStorage.getItem('glovoNoteOrder') : null;
  const localHtml = typeof window !== 'undefined' ? localStorage.getItem('glovoNoteHtml') : null;
  const localOrder = typeof window !== 'undefined' ? localStorage.getItem('glovoNoteOrder') : null;

  const html = sessionHtml || localHtml || textParam || '';
  const orderNumber = sessionOrder || localOrder || orderNumberParam || '';

  useEffect(() => {
    document.body.classList.add('glovo-print');
    const timer = setTimeout(() => window.print(), 500);
    return () => {
      clearTimeout(timer);
      document.body.classList.remove('glovo-print');
      // cleanup session storage after printing
      try {
        sessionStorage.removeItem('glovoNoteHtml');
        sessionStorage.removeItem('glovoNoteOrder');
        localStorage.removeItem('glovoNoteHtml');
        localStorage.removeItem('glovoNoteOrder');
      } catch (e) {}
    };
  }, []);

  // derive plain text length to adjust font size
  const plain = (html || '').replace(/<[^>]+>/g, '').trim();
  const len = plain.length;
  let fontSizePx = 18;
  if (len <= 200) fontSizePx = 36;
  else if (len <= 500) fontSizePx = 28;
  else if (len <= 1000) fontSizePx = 20;
  else if (len <= 2000) fontSizePx = 14;
  else fontSizePx = 12;

  const style = {
    width: '100%',
    maxWidth: '100%',
    minHeight: '100mm',
    padding: '5mm',
    fontSize: `${fontSizePx}px`,
    boxSizing: 'border-box'
  };

  const hasContent = (html || '').replace(/<[^>]+>/g, '').trim().length > 0;

  if (!hasContent) {
    return (
      <div id="glovo-note-print" style={style}>
        <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#6B7280' }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontWeight: 700, fontSize: '16px' }}>No note to print</div>
            <div style={{ marginTop: 8 }}>The note content is empty.</div>
          </div>
        </div>
      </div>
    );
  }

  // Render centered note content; order number stays at the top-left
  // Render centered, full-width note without decorative square
  return (
    <div id="glovo-note-print" style={{ ...style, display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
      {orderNumber && !(html || '').includes(`#${orderNumber}`) && (
        <div style={{ fontWeight: 700, fontSize: `${Math.max(12, Math.floor(fontSizePx * 0.8))}px`, marginBottom: 6 }}>#{orderNumber}</div>
      )}
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ width: '100%', textAlign: 'center', fontSize: `${fontSizePx}px`, lineHeight: 1.1, whiteSpace: 'pre-wrap', wordBreak: 'break-word', margin: '0 auto' }} dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    </div>
  );
};

export default GlovoNotePrint;
